import React, { Component, Fragment} from 'react'
import Breadcrumb from "../../common/breadcrumb"
import Modal from 'react-responsive-modal';
import 'react-toastify/dist/ReactToastify.css';
import Datatable from '../../common/datatable'
import {Link} from 'react-router-dom'
import { getObjects, updateObject, deleteObject } from "../../api";

export class TUserList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            loading: true, // set to false once loading is completed
            editingRow: {},
            actionMode: ''
        };
    }

    onOpenModal = () => {
        this.setState({ editingRow: {}, actionMode: 'new', open: true });
    };

    onCloseModal = (mode) => {
        this.setState({ open: false });
        if(mode === true)
        {
            if (document.getElementById("newTuser").elements['actionMode'].value === 'new') {
                this.onCreateTuser(document.getElementById("newTuser").elements['tuserName'].value);
            } else if (document.getElementById("newTuser").elements['actionMode'].value === 'update') {
                this.onUpdateTuser(  document.getElementById("newTuser").elements['itemId'].value,
                                        document.getElementById("newTuser").elements['tuserName'].value);
            } else {
                this.onDeleteTuser(  document.getElementById("newTuser").elements['itemId'].value);
            }
        } else {
            console.log('cancel');
        }
    };

    onItemEdit = (row) => {
        this.props.history.push(`/admin/tuser/edit?pid=${row._id}`)
        //this.setState({editingRow: row, actionMode: 'update', open: true });
    };

    onItemDashboard = (row) => {
        this.props.history.push(`/pages/dashboard?uid=${row._id}`)
        //this.setState({editingRow: row, actionMode: 'update', open: true });
    };

    onItemDelete = (row) => {
        this.setState({editingRow: row, actionMode: 'delete', open: true });        
    };

    onCreateTuser = (name) => {
        updateObject('tuser',  { name }).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.loadTusers();
            }
        });
    };

    onUpdateTuser = (id, name) => {
        updateObject('tuser', { "name": name }, id).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.loadTusers();
                }
            }
        );
    };

    onDeleteTuser = (id) => {
        deleteObject('tuser', id).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.loadTusers();
            }
        });
    };

    loadTusers = () => {
        this.setState({ loading: true});
        getObjects('tuser').then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({ data: d2, loading: false});
            }
        });
    };

    componentDidMount(){
        this.loadTusers();
    }

    render() {
        const { open } = this.state;

        if (this.state.loading) { return null; }
        else {
            setTimeout(function() {
                document.querySelector(".loader-wrapper").style = "display: none";
            }, 100);       

        return (
            <Fragment>
                <Breadcrumb title="Tuser List" />
                
                {/* <!-- Container-fluid starts--> */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className="btn-popup pull-right">
                                        <Link to="/admin/tuser/edit">
                                            <button type="button" className="btn btn-primary">Add Tuser</button>  
                                        </Link>                                        
                                        <Modal open={open} onClose={this.onCloseModal} >
                                            <div className="modal-header">
                                                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                                                {this.state.actionMode==='delete'?'Delete ':this.state.actionMode==='update'?'Update ':'Add '}
                                                Tuser</h5>
                                            </div>
                                            <div className="modal-body">
                                                <form id="newTuser">
                                                    <input type="hidden" id="itemId" value={this.state.editingRow._id?this.state.editingRow._id:''} />
                                                    <input type="hidden" id="actionMode" value={this.state.actionMode} />
                                                    <div className="form-group">
                                                        <label htmlFor="recipient-name" className="col-form-label" >Tuser Name :</label>
                                                        <input id="tuserName" defaultValue={this.state.editingRow.name?this.state.editingRow.name:''} type="text" className="form-control" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="message-text" className="col-form-label">Tuser Image :</label>
                                                        <input className="form-control" id="validationCustom02" type="file" />
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal(true)}>{this.state.actionMode==='delete'?'Delete':'Save'}</button>
                                                <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal(false)}>Close</button>
                                            </div>
                                        </Modal>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div id="basicScenario" className="category-table order-table tuser-list-delete">
                                        <Datatable
                                            multiSelectOption={false}
                                            myData={this.state.data}
                                            columns={['displayname', 'email', 'permissions']}     
                                            pageSize={10}
                                            pagination={true}
                                            onItemDelete={this.onItemDelete}
                                            onItemEdit={this.onItemEdit}
                                            onItemDashboard={this.onItemDashboard}    
                                            class="-striped -highlight"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Container-fluid Ends--> */}
            </Fragment>
        )
    }
    }
}

export default TUserList





